<section class="main-section">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Notifications</li>
        </ol>
    </nav>
    <div class="row align-items-center">
        <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>
        <div class="col-6">
            <ul class="list-inline tab-list deskContent">
                <li class="list-inline-item"><a (click)="populateTabData('all','ALL'); tabChange();" [ngClass]="{'active': tabClicked === 'all'}">All</a></li>

                <li class="list-inline-item"><a (click)="populateTabData('active','ACTIVE');  tabChange();" [ngClass]="{'active': tabClicked === 'active'}">Active</a></li>
                <li class="list-inline-item"><a (click)="populateTabData('inactive','IN_ACTIVE'); tabChange();" [ngClass]="{'active': tabClicked === 'inactive'}">Inactive</a></li>
            </ul>
          <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2" [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" data-value="All" required>
            <option  value="ALL">All</option>
            <option  value="ACTIVE">Active</option>
            <option  value="IN_ACTIVE">Inactive</option>
          </select>
        </div>
        <div class="col-6 text-right float-right">
            <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-outline-primary btn-sm ml-2 dropdown-toggle d-none-mobile"  *ngIf="(checkedList?.length) && tabClicked !== 'all'">Actions</button>
<!--
            <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
-->
          <a placement="bottom" ngbTooltip="Create" class="ml-3">
            <svg xmlns="http://www.w3.org/2000/svg" routerLink="/admin/createNotify" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z" transform="translate(2.823 3.938)"/></g></svg>
          </a>
            <!--<a routerLink="/admin/createNotify" class="btn btn-outline-primary btn-sm ml-2"><svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
        <path fill-rule="evenodd" d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
      </svg>Create</a>-->
            <div class="dropdown-menu dropdown-menu2 ml-3 dropdown-menu-right" *ngIf="(checkedList?.length) && tabClicked !== 'all'">
                <!--          <a *ngIf="tabClicked === 'active' || tabClicked === 'inactive' || tabClicked === 'all'" (click)="editNotification(notificationTypes)" class="dropdown-item file btn shift-import">Edit</a>-->
                <button *ngIf="tabClicked === 'active' || tabClicked === 'inactive' || tabClicked === 'all'" class="dropdown-item file btn shift-import" data-target="#deleteNotifyModal" data-toggle="modal" [disabled]="(!checkedList?.length)">Delete </button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
                <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                    <thead>
                        <tr>
                            <th [hidden]="tabClicked == 'all'">
                              <!--  <div class="form-checkbox">
                                    <input type="checkbox" id="all_items" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()" />
                                    <label for="all_items"></label>
                                </div>-->
                            </th>
                            <th>Type</th>
                            <th>Message</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody class="table-body-custom">
                        <tr *ngFor="let n of notificationTypes">
                            <td [hidden]="tabClicked == 'all'">
                                <div class="form-checkbox">
                                    <input type="checkbox" id="{{n.notificationId}}" [(ngModel)]="n.isSelected" name="list_name" (change)="selectShip(n)">
                                    <label for="{{n.notificationId}}"></label></div>
                            </td>
                            <td><a routerLink="/admin/editNotify/{{n.notificationId}}">{{n.type}}</a></td>
                            <td>{{n.description}}</td>
                            <td>
                                <div class="toggle-2">
                                    <input type="checkbox" name="onoffswitch" id="customSwitch_{{n.notificationId}}" class="custom-control-input" (click)="changeStatus(n)" [checked]="n.status==='ACTIVE'" class="checkbox" />
                                    <label for="customSwitch_{{n.notificationId}}" class="toggle">
                     <span>ON</span><span>OFF</span>
                   </label>
                                </div>
                                <!--
                 <div class="custom-control custom-switch">
                    <input type="checkbox"  class="custom-control-input" (click)="changeStatus(n)" id="customSwitch_{{n.notificationId}}" [checked]="n.status==='ACTIVE'">
                    <label class="custom-control-label" for="customSwitch_{{n.notificationId}}"> </label>
                  </div>
-->
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr *ngIf="notificationTypes?.length===0|| !notificationTypes?.length">
                            <td colspan="4" class="text-center">No matching records found</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="inner-box d-block d-sm-none">
                <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Message</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let n of notificationTypes">
                            <td><b class=" tablesaw-cell-label">Type</b>
                                <span class="tablesaw-cell-content"><a routerLink="/admin/editNotify/{{n.notificationId}}">{{n.type}}</a></span></td>
                            <td><b class=" tablesaw-cell-label">Message</b>
                                <span class="tablesaw-cell-content">{{n.description}}</span></td>
                            <td>
                                <b class=" tablesaw-cell-label">Status</b>
                                <span class="tablesaw-cell-content">
              <div class="custom-control custom-switch">
                <input type="checkbox"  class="custom-control-input" (click)="changeStatus(n)" id="customSwitch_{{n.notificationId}}" [checked]="n.status==='ACTIVE'">
                <label class="custom-control-label" for="customSwitch_{{n.notificationId}}"> </label>
              </div>
              </span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>

<div class="container">
    <!-- Modal -->
    <div class="modal fade" id="deleteNotifyModal" role="dialog">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Delete</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <p>Do you really want to delete </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-delete" data-dismiss="modal">No</button>
                    <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="deleteNotificatios(notificationTypes)">Yes</button>
                </div>
            </div>
        </div>
    </div>
</div>
